var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-wrap"},[_c('div',{staticClass:"q-gutter-xl q-ma-xl"},[_c('h4',[_vm._v(_vm._s(_vm.$t('errors.unexpected_error')))]),_c('q-img',{attrs:{"src":require('@/assets/images/errors/error.svg'),"width":"40%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }